export default __webpack_public_path__ + "static/media/featuresField.6332ad4a.svg";